import React, { useEffect, useState } from 'react';
import { Tabs } from '@amzn/awsui-components-react/polaris';
import ServiceCollection from 'src/services/ServiceCollection';
import TablesView from 'src/components/custom-tables/TablesView';
import SegmentTablesView from 'src/components/segment-cdt/list/SegmentTablesView';
import { getFeatureFlags } from 'src/services/FeatureFlagsService';

/**
 * Host for the Custom Data Tables page. When `segmentCdtEnabled` is on it splits into
 * "CLI Data Tables" (the existing view) and "Segment Data Tables" (new) tabs. When the flag is off
 * or still resolving it renders the CLI view directly with no tab chrome — so the established screen
 * is byte-for-byte unchanged while the segment feature ships dark.
 */
export default function CustomDataTablesPage(props: { services: ServiceCollection }) {
    const { services } = props;
    const [segmentEnabled, setSegmentEnabled] = useState<boolean | null>(null);
    // Default to the CLI tab: enabling segmentCdtEnabled must not drop existing users onto the
    // (currently backend-less) Segment tab. This also defers the Segment list fetch until its tab
    // is opened, so no error surfaces on initial load.
    const [activeTabId, setActiveTabId] = useState('cli');

    useEffect(() => {
        let active = true;
        getFeatureFlags().then(flags => { if (active) { setSegmentEnabled(flags.segmentCdtEnabled); } });
        return () => { active = false; };
    }, []);

    if (!segmentEnabled) {
        return <TablesView services={services} />;
    }

    return (
        <Tabs
            activeTabId={activeTabId}
            onChange={({ detail }) => setActiveTabId(detail.activeTabId)}
            tabs={[
                { id: 'cli', label: 'CLI Data Tables', content: <TablesView services={services} /> },
                { id: 'segment', label: 'Segment Data Tables', content: <SegmentTablesView services={services} /> },
            ]}
        />
    );
}
